import Plugin from 'src/plugin-system/plugin.class';
import tippy, {sticky} from 'tippy.js';
//import 'tippy.js/dist/tippy.css';

export default class SideWidgetPlugin extends Plugin {
 
    init() {
        var button1 = document.querySelector('#popcorn1');
        var tooltip1 = document.querySelector('#tooltip1');

        tippy(button1, {
            content: tooltip1.innerHTML,
            allowHTML: true,
            interactive: true,
            appendTo: () => document.body,
            placement: 'left',
            sticky: true,
            theme: 'light',
            trigger: 'click',
            plugins: [ sticky ]
        });

        var button2 = document.querySelector('#popcorn2');
        var tooltip2 = document.querySelector('#tooltip2');

        tippy(button2, {
            content: tooltip2.innerHTML,
            allowHTML: true,
            interactive: true,
            appendTo: () => document.body,
            placement: 'left',
            sticky: true,
            theme: 'light',
            trigger: 'click',
            plugins: [ sticky ]
        });

    }

}